import { ImmutabilityContext } from '../effects/customImmutabilityContext';
import {
  PostEditorReducerFunction,
  PostEditorSetEvergreenRecycleExpireCountAction,
  PostEditorSetEvergreenRecycleExpireDateAction,
  PostEditorSetEvergreenRecycleTypeAction
} from '../PostEditorActions';
import { OnStateUpdateCallbackFunction, postGroupStateUpdater } from '../../helpers/postGroupStateUpdater';
import { validatorStateUpdater } from '../../validators/helpers/validatorStateUpdater';
import { ErrorMessageSeverity } from '../../../../constants/form';
import { EvergreenType } from '../../../../models/post-editor';

export const setEvergreenRecycleExpireCountReducer: PostEditorReducerFunction<
  PostEditorSetEvergreenRecycleExpireCountAction['payload']
> = (state, payload) => {
  const { postGroupIndex, counter, type, customizeIndex } = payload;
  const { update: updateImmutable } = ImmutabilityContext;
  const callback: OnStateUpdateCallbackFunction = currentPost =>
    updateImmutable(currentPost, {
      scheduling: {
        [type]: {
          expiryMaxRepeats: { $set: counter }
        }
      }
    });
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkExpiryCount',
    'expireCountRequired',
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};

export const setEvergreenRecycleExpireDate: PostEditorReducerFunction<
  PostEditorSetEvergreenRecycleExpireDateAction['payload']
> = (state, payload) => {
  const { postGroupIndex, date, type, customizeIndex } = payload;
  const dateStr = date.toLocaleDateString('en-US').split('/');
  const formattedDate = `${dateStr[2]}-${dateStr[0].padStart(2, '0')}-${dateStr[1].padStart(2, '0')}`;
  const callback: OnStateUpdateCallbackFunction = currentPost => {
    const { update: updateImmutable } = ImmutabilityContext;
    return updateImmutable(currentPost, {
      scheduling: {
        [type]: {
          expiryDate: { $set: formattedDate }
        }
      }
    });
  };
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkExpiryDate',
    'expireDateRequired',
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};

export const setEvergreenRecycleTypeReducer: PostEditorReducerFunction<
  PostEditorSetEvergreenRecycleTypeAction['payload']
> = (state, payload) => {
  const { postGroupIndex, expireType, type, customizeIndex, action } = payload;
  const callback: OnStateUpdateCallbackFunction = currentPost => {
    const { update: updateImmutable } = ImmutabilityContext;
    return updateImmutable(currentPost, {
      scheduling: {
        [type]: {
          expireType: {
            $apply: (current: EvergreenType['expireType']) => {
              const indexOfCurrent = current.indexOf(expireType);
              if (action === 'remove' && indexOfCurrent > -1) {
                current.splice(indexOfCurrent, 1);
                return current;
              }
              if (action === 'add' && indexOfCurrent === -1) {
                return [...current, expireType];
              }
              return current;
            }
          }
        }
      }
    });
  };
  const result = postGroupStateUpdater(state, postGroupIndex, customizeIndex, 'schedule', callback);
  return validatorStateUpdater(result, postGroupIndex, ErrorMessageSeverity.warning, [
    'checkExpiryCount',
    'checkExpiryDate',
    'expireDateRequired',
    'expireCountRequired',
    'profileRequired',
    'scheduleTextOrMediaVariations'
  ]);
};
